import { Component } from '@angular/core'

@Component({
  selector: '[app-select-menu-list]',
  styles: `
    :host {
        list-style: none;
        width: 100%;
        max-height: 16rem;
        overflow-y: scroll;
        margin: 0;
        padding: 0;
    }
    `,
  template: '<ng-content></ng-content>',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SelectMenuListComponent {}
